import { render, staticRenderFns } from "./BaseSignInWelcomePanel.vue?vue&type=template&id=4350c3b1&"
import script from "./BaseSignInWelcomePanel.vue?vue&type=script&lang=js&"
export * from "./BaseSignInWelcomePanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseSignInWelcomePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports